import React from "react";

function InfoBlock(props) {
  return (
    <div
      style={{
        padding: "20px",
        borderWidth: "1px",
        borderRadius: "3px",
        boxShadow: "0px 0px 0px 1px rgba(0,0,0,0.3)",
        background: "#d6d0d030",
        margin: "0 0 15px 0",
      }}
    >
      <span
        style={{
          fontSize: "20px",
          borderBottom: "solid rgba(0,0,0,0.3)",
        }}
      >
        {props.title}
      </span>
      <div
        style={{
          padding: "20px 5px 0px 5px",
          fontSize: "14px",
        }}
      >
        {props.children}
      </div>
    </div>
  );
}

export default InfoBlock;
